// AUTO-GENERATED by scripts/build-registry.js: study entry for air-law/ads-b.
import { mount } from '#engine/lesson-page.js';
import g0 from '../lessons/air-law/ads-b/ads-b-flight-id.js';
import g1 from '../lessons/air-law/ads-b/ads-b-track-identifier.js';
import g2 from '../lessons/air-law/ads-b/ads-b.js';

mount([g0, g1, g2]);
